<ng-container (scroll)="windowPosition()" *ngIf='!accessDenied'>
    <div *ngIf='!loader' class="w-100 float-left">
        <div class="w-100 float-left v-align relative">
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">ANALYTICAL MODELLER</h5>
                <div style="flex-grow: 1;"></div>
                <button *ngIf="cubeScreen && !editScreen" id="clear" (click)="clearCache()"
                        class="btn btn-primary float-right mr-3">Clear All Cube Cache
                </button>
                <button *ngIf="cubeScreen && !editScreen" id="upload" (click)="createNew()"
                        class="btn btn-primary float-right mr-3">Create New
                </button>
                <div *ngIf="!!analyticalModel" class="col-lg-2 col-md-2 float-right">
                    <button id="nextMeasure " (click)="saveAnalyticalModel()" class="btn btn-primary float-right">Save
                        Analytical
                        Model
                    </button>
                </div>
                <button *ngIf="!cubeScreen || editScreen" id="cancelAll" (click)="cancelDesigner()"
                        class="btn btn-primary float-right mr-3">Cancel
                </button>
            </div>
        </div>
        <designerCube *ngIf="cubeScreen" (emitEdit)="setMapperScreen($event)"
                      (emitCubeData)="setCubeForEdit($event)"></designerCube>
        <div *ngIf="!cubeScreen || editScreen" class="w-100 float-left mt-3">
            <div class="feedback-pills">
                <ngb-tabset type="pills" activeId="{{activeScreen}}" (tabChange)="beforeChange($event)">
                    <ngb-tab title="Step 1: Setup" id="upload">
                        <ng-template ngbTabContent="ngbTabContent">
                            <div class="col-lg-6 col-md-6 float-left">
                                <div *ngIf="isEdit && selectedDataSource.dataEngine.type == 'DRILL'"
                                     class="form-group w-100 float-left text-center mt-4">
                                    <b>Reupload</b>
                                </div>
                                <div *ngIf="!isEdit" class="form-group w-100 float-left">
                                    <label for="dataSourceId">Data Source</label>
                                    <select class="form-control light-bg" (change)="selectDataSource($event)">
                                        <option value='none'>None</option>
                                        <option [attr.selected]="selectedDataSource && selectedDataSource.id == datasource.id ? true : null"
                                                *ngFor="let datasource of dataSourceList"
                                                [attr.value]='datasource.id'>{{datasource.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <input *ngIf="selectedDataSource != undefined && selectedDataSource.dataEngine.type == 'DRILL'"
                                   type='file' class="mt-4 ml-2"
                                   #fileHolder multipart=true name="file" (change)="fileChange($event)"/>
                            <div *ngIf="selectedDataSource != undefined && selectedDataSource.dataEngine.type == 'DRILL'"
                                 class="modal-footer border-top-0 p-4">
                                <button [disabled]="saveButton" class="btn btn-primary" (click)="uploadFile()">Upload
                                </button>
                            </div>
                            <!-- FOR PRESTO -->
                            <div *ngIf="!isEdit && selectedDataSource != undefined && (selectedDataSource.dataEngine.type == 'PRESTO' || selectedDataSource.dataEngine.type == 'CLICK_HOUSE')"
                                 class="modal-footer border-top-0 p-4">
                                <button [disabled]="saveButton" class="btn btn-primary"
                                        (click)="scanPresto(selectedDataSource.id)">Scan
                                </button>
                            </div>
                            <div *ngIf="isEdit && selectedDataSource != undefined && (selectedDataSource.dataEngine.type == 'PRESTO' || selectedDataSource.dataEngine.type == 'CLICK_HOUSE')"
                                 class="modal-footer border-top-0 p-4">
                                <button class="btn btn-primary" (click)="reSyncPresto()">Re-Scan</button>
                            </div>
                            <div *ngIf="!isEdit && prestoData != undefined && (selectedDataSource.dataEngine.type == 'PRESTO' || selectedDataSource.dataEngine.type == 'CLICK_HOUSE')">
                                <div class="form-group w-100 float-left">
                                    <label for="dataSourceId">Type</label>
                                    <select class="form-control light-bg p-1" (change)="selectType($event)">
                                        <option [attr.selected]="isStarSchema == null ? true : null" value="none">None
                                        </option>
                                        <option [attr.selected]="isStarSchema == false ? true : null"
                                                value="materialized">Materialized
                                        </option>
                                        <option [attr.selected]="isStarSchema == true ? true : null" value="starschema">
                                            Star Schema
                                        </option>
                                    </select>
                                </div>
                                <div *ngIf="isStarSchema != undefined" class="form-group w-30 w-100 float-left">
                                    <label>Fact</label>
                                    <select class="form-control light-bg p-1" (change)="selectFact($event)">
                                        <option value="none">None</option>
                                        <option [attr.selected]="selectedFact && selectedFact == prestoData.refId ? true : null"
                                                *ngFor="let prestoData of prestoData"
                                                [attr.value]='prestoData.refId'>{{prestoData.displayName}}
                                        </option>
                                    </select>
                                </div>
                                <div *ngIf="isStarSchema != undefined" class="modal-footer border-top-0 p-4">
                                    <button [disabled]="saveButton" class="btn btn-primary" (click)="uploadPresto()">
                                        Next
                                    </button>
                                </div>
                            </div>

                            <!-- ADDING OR UPDATING CUBE -->
                            <div class="w-100 float-left" *ngIf="editScreen">
                                <div class="w-100 float-left mt-3">
                                    <div class='col-lg-6 col-md-6 float-left left-clear'>
                                        <div class="form-group">
                                            <label> Name
                                                <span class="text-danger medium">*</span>
                                            </label>
                                            <input maxlength="200" type="text" class="form-control"
                                                   [(ngModel)]="analyticalModel.cube.name" name="name"
                                                   placeholder=" Cube Name"/>
                                        </div>
                                    </div>
                                    <div class='col-lg-6 col-md-6 float-left'>
                                        <div *ngIf='analyticalModel.cube.dataSourceData' class="form-group w-100">
                                            <label for="dropDown">Data Source</label>
                                            <input readonly class="form-control" type="text" id="dataSource"
                                                   maxlength="100"
                                                   [(ngModel)]="selectedDataSource.name"
                                                   placeholder=" Data Source Name"/>
                                        </div>
                                    </div>
                                    <div class='col-lg-6 col-md-6 float-left left-clear'>
                                        <div class="form-group">
                                            <label> Description
                                                <span class="text-danger medium"></span>
                                            </label>
                                            <textarea maxlength="350" class="form-control" rows="1"
                                                      [(ngModel)]="analyticalModel.cube.description"
                                                      name="description"
                                                      placeholder="Description (Optional)"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 float-left">
                                        <div class="form-group w-100 float-left">
                                            <label for="recordFormat">Record Format</label>
                                            <input readonly class="form-control" type="text" id="dataSource"
                                                   maxlength="100"
                                                   [(ngModel)]="analyticalModel.fact.name"/>
                                        </div>
                                    </div>
                                    <div class='col-lg-6 col-md-6 float-left mt-3'>
                                        <div class="w-100 float-left align-v-center">
                                            <label for="enableCache" class="mb-0 mr-3"> Enable Cache</label>
                                            <input id="enableCache" type="checkbox"
                                                   [(ngModel)]="analyticalModel.cube.enableCache">
                                        </div>
                                    </div>
                                    <div *ngIf="isStarSchema != null" class="col-lg-6 col-md-6 float-right">
                                        <div class="form-group w-100 float-left">
                                            <label for="type">Type</label>
                                            <input readonly class="form-control" type="text" id="prestotype"
                                                   maxlength="100"
                                                   [(ngModel)]="selectedType"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-100 float-left mt-3">
                                    <div class='col-lg-6 col-md-6 float-left'>
                                        <label for="cubeData">Data Version Type</label>
                                        <select class="form-control light-bg" [ngModel]="dataVersionType"
                                                (change)="setdataVersionType($event.target.value)">
                                            <option value="Dynamic">Dynamic</option>
                                            <option value="Static">Static</option>
                                        </select>
                                    </div>
                                    <div class='col-lg-3 col-md-3 float-left'>
                                        <label for="cubeStartDate">Start Data Version</label>
                                        <div class="form-group">
                                            <div class='col-sx-8 float-left left-clear'>
                                                <input class="form-control light-bg" placeholder="YYYYMMDD"
                                                       name="startDate" ngbDatepicker
                                                       [(ngModel)]="startDataVersion" #d="ngbDatepicker" readonly>
                                                <ngb-timepicker
                                                        *ngIf="startDataVersion && startDataVersion.day != undefined"
                                                        [(ngModel)]="startDataVersionTime"
                                                        (ngModelChange)="setStartDvTime($event)"></ngb-timepicker>
                                            </div>
                                            <div class="col-sx-1 float-left">
                                                <button class="iga-left form-control light-bg" (click)="d.toggle()"
                                                        type="button">
                                                    <i class="fa fa-calendar"></i>
                                                </button>
                                            </div>
                                            <button (click)="clearStartDate()" type="button">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class='col-lg-3 col-md-3 float-left' *ngIf="dataVersionType=='Static'">
                                        <label for="cubeDataVersion">End Data Version</label>
                                        <div class="form-group">
                                            <div class='col-sx-8 float-left left-clear'>
                                                <input class="form-control light-bg" placeholder="YYYYMMDD"
                                                       name="DataVersionDate" ngbDatepicker
                                                       [(ngModel)]="dataVersionDate" #d="ngbDatepicker" readonly>
                                                <ngb-timepicker
                                                        *ngIf="dataVersionDate && dataVersionDate.day != undefined"
                                                        [(ngModel)]="dataVersionTime"
                                                        (ngModelChange)="setDvTime($event)"></ngb-timepicker>
                                            </div>
                                            <div class="col-sx-1 float-left">
                                                <button class="iga-left form-control light-bg" (click)="d.toggle()"
                                                        type="button">
                                                    <i class="fa fa-calendar"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngb-tab>
                    <ngb-tab *ngIf="analyticalModel != undefined" title="Step 2: Setup Columns" id="mapper">
                        <ng-template ngbTabContent="ngbTabContent">
                            <div *ngIf="analyticalModel == undefined">
                                <b> No Data to setup</b>
                            </div>
                            <ng-container *ngIf="analyticalModel != undefined && analyticalModel.fact">
                                <b>{{analyticalModel.fact.recordFormatFieldData.length}} fields found, </b>
                                Measures - {{analyticalModel.cube.cubeMeasureData.length}}, Dimensions -
                                {{analyticalModel.cube.cubeDimensionUsageData.length}}

                                <dataMapper *ngIf="!!analyticalModel" [analyticalModelData]="analyticalModel"
                                            (measureListSender)="setMeasureList($event)"
                                            (dimensionListSender)="setDimensionList($event)"
                                            (dimValidationSender)="prestoDimValidation($event)"
                                            [dimensionList]="dimensionList" [isStarSchema]="isStarSchema"
                                            (formulaMeasureEmitter)="setFormulaList($event)"></dataMapper>
                            </ng-container>
                        </ng-template>
                    </ngb-tab>
                    <ngb-tab *ngIf="analyticalModel != undefined" title="Step 3: Setup Dimension" id="dimEdit">
                        <ng-template ngbTabContent="ngbTabContent">
                            <ng-container *ngIf="!editDimensionPage">
                                <div *ngIf='analyticalModel && analyticalModel.cube.cubeDimensionUsageData.length == 0'>
                                    <h4>
                                        <b>No Dimensions to setup</b>
                                    </h4>
                                </div>
                                <ng-container *ngIf='analyticalModel'>
                                    <div class="w-100 float-left"
                                         *ngIf='analyticalModel && analyticalModel.cube.cubeDimensionUsageData && analyticalModel.cube.cubeDimensionUsageData.length'>
                                        <b>Number of Dimensions -
                                            {{analyticalModel.cube.cubeDimensionUsageData.length}}</b>
                                        <div class="light-bg w-100 float-left p-2 grid-details">
                                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                                 ngbTooltip="Code">
                                                <h6 class="mb-lg-0 medium text-truncate"> Code </h6>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                                 ngbTooltip="Name">
                                                <h6 class="mb-lg-0 medium text-truncate"> Name </h6>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                                 ngbTooltip="Description">
                                                <h6 class="mb-lg-0 medium text-truncate"> Description </h6>
                                            </div>
                                            <div *ngIf="isStarSchema != true"
                                                 class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"
                                                 ngbTooltip="Actions">
                                                <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-100 float-left p-md-2 grid-details"
                                         *ngFor="let dim of analyticalModel.cube.cubeDimensionUsageData;">

                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                             ngbTooltip="{{dim.dimensionData.dimCode}}">
                                            <h6 class="mb-lg-0 text-truncate"> {{dim.dimensionData.dimCode}} </h6>
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                             ngbTooltip="{{dim.dimensionData.name}}">
                                            <h6 class="mb-lg-0 text-truncate"
                                                [innerHTML]='!!dim.dimensionData.displayName ? dim.dimensionData.displayName : dim.dimensionData.name'></h6>
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                             ngbTooltip="{{dim.dimensionData.description}}">
                                            <h6 class="mb-lg-0 text-truncate"> {{dim.dimensionData.description}} </h6>
                                        </div>
                                        <!-- <div *ngIf="isStarSchema != true" class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" >
                                            <h6 class="mb-lg-0" ngbtooltip="Click for more options" ng-reflect-ngb-tooltip="Click for more options">
                                                <i class="fa fa-ellipsis-h" [id]="dim.dimensionData.refId" (click)=entityOpsDimension($event)></i>
                                            </h6>
                                            <div class="empActions m-t-nsmd" *ngIf="selectedDim == dim.dimensionData.refId">
                                                <i class="fa fa-caret-up caret-up"></i>
                                                <ul class="m-0 p-0">
                                                    <li (click)="editDimension(dim.dimensionData)">
                                                        <i class="fa fa-pencil mr-2"></i>Edit
                                                    </li>
                                                     <li (click)="removeDimension(dim)">
                                                        <i class="fa fa-trash mr-2"></i>Delete
                                                    </li> -->
                                        <!--</ul>
                                    </div>
                                </div> -->
                                        <div *ngIf="isStarSchema != true"
                                             class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"
                                             [id]="dim.dimensionData.refId" (mouseenter)=entityOpsDimension($event)
                                             (mouseleave)=closeDropDown($event)>
                                            <h6 class="mb-lg-0">
                                                <i class="fa fa-ellipsis-h"></i>
                                            </h6>
                                            <div class="empActions m-t-nsmd" style="top:29px"
                                                 *ngIf="selectedDim == dim.dimensionData.refId">
                                                <i class="fa fa-caret-up caret-up"></i>
                                                <ul class="m-0 p-0">
                                                    <li (click)="editDimension(dim.dimensionData)">
                                                        <i class="fa fa-pencil mr-2"></i>Edit
                                                    </li>
                                                    <!-- <li (click)="removeDimension(dim)">
                                                        <i class="fa fa-trash mr-2"></i>Delete
                                                    </li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="editDimensionPage">
                                <dimensionEditor [dimensionData]="dimensionData" [isEdit]="isEdit"
                                                 (triggerSave)="afterEditDim($event)"
                                                 (triggerBack)="onBackFromDimEdit()"
                                                 [parent]="'wizard'"
                                                 [recordFormat]="analyticalModel.fact"></dimensionEditor>
                            </ng-container>
                        </ng-template>
                    </ngb-tab>
                    <ngb-tab *ngIf="analyticalModel != undefined" title="Step 4: Setup Measure" id="measureEdit">
                        <ng-template ngbTabContent="ngbTabContent">
                            <ng-container *ngIf="!editMeasurePage">
                                <div *ngIf='analyticalModel && analyticalModel.cube.cubeMeasureData.length == 0'>
                                    <h4><b>No Measures to setup</b>
                                    </h4>
                                </div>
                                <ng-container *ngIf='analyticalModel'>
                                    <div class="w-100 float-left"
                                         *ngIf='analyticalModel && analyticalModel.cube.cubeMeasureData && analyticalModel.cube.cubeMeasureData.length'>
                                        <b>Number of Measures - {{analyticalModel.cube.cubeMeasureData.length}}</b>
                                        <button id="addFormulaMeasure" (click)="addFormulaMeasure()"
                                                class="btn btn-primary float-right">Add Formula Measure
                                        </button>
                                        <div class="light-bg w-100 float-left p-2 grid-details">
                                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                                 ngbTooltip="Code">
                                                <h6 class="mb-lg-0 medium text-truncate"> Code </h6>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                                 ngbTooltip="Name">
                                                <h6 class="mb-lg-0 medium text-truncate"> Name </h6>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                                 ngbTooltip="Description">
                                                <h6 class="mb-lg-0 medium text-truncate"> Description </h6>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                                 ngbTooltip="Data Version">
                                                <h6 class="mb-lg-0 medium text-truncate"> Data Version </h6>
                                            </div>
                                            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"
                                                 ngbTooltip="Actions">
                                                <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-100 float-left p-md-2 grid-details"
                                         *ngFor="let measure of analyticalModel.cube.cubeMeasureData;">

                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                             ngbTooltip="{{measure.measureData.measureCode}}">
                                            <h6 class="mb-lg-0 text-truncate"> {{measure.measureData.measureCode}} </h6>
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                             ngbTooltip="{{measure.measureData.measureDisplayName}}">
                                            <h6 class="mb-lg-0 text-truncate">
                                                {{measure.measureData.measureDisplayName}}
                                            </h6>
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                             ngbTooltip="{{measure.measureData.description}}">
                                            <h6 class="mb-lg-0 text-truncate"> {{measure.measureData.description}} </h6>
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                             ngbTooltip="{{measure.measureData.dataVersion | date:mediumDate}}">
                                            <h6 class="mb-lg-0 text-truncate"> {{measure.measureData.dataVersion |
                                                date:mediumDate}}
                                            </h6>
                                        </div>
                                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"
                                             [id]="measure.measureData.refId" (mouseenter)=entityOpsMeasure($event)
                                             (mouseleave)="closeDropDown($event)">
                                            <h6 class="mb-lg-0">
                                                <i class="fa fa-ellipsis-h"></i>
                                            </h6>
                                            <div class="empActions m-t-nsmd" style="top:29px"
                                                 *ngIf="selectedMeasureId == measure.measureData.refId">
                                                <i class="fa fa-caret-up caret-up"></i>
                                                <ul class="m-0 p-0">
                                                    <li (click)="editMeasure(measure.measureData)">
                                                        <i class="fa fa-pencil mr-2"></i>Edit
                                                    </li>
                                                    <li *ngIf="isFormulaMeasure" (click)="removeMeasure(measure)">
                                                        <i class="fa fa-trash mr-2"></i>Delete
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="editMeasurePage">
                                <measureEditor [parent]="'wizard'" [isStarSchema]="isStarSchema" [inEdit]="inMesEdit"
                                               [measureData]="measureData" [isEdit]="isEdit"
                                               (triggerSave)="afterEditMeasure($event)"
                                               (triggerBack)="onBackFromMeasureEdit()"
                                               [targetDimensionList]="analyticalModel.cube.cubeDimensionUsageData"
                                               [targetMeasureList]="analyticalModel.cube.cubeMeasureData"
                                               [formulaMeasure]="isFormulaMeasure"></measureEditor>
                            </ng-container>
                        </ng-template>
                    </ngb-tab>
                    <ngb-tab *ngIf="analyticalModel != undefined" title="Step 5: Preview" id="preview">
                        <ng-template ngbTabContent="ngbTabContent">
                            <ng-container>
                                <dataPreview (pageDetailsSender)="getPreviewPageDetails($event)"
                                             [tntConfData]="tntConfData"
                                             [previewAnalyticalModel]="previewAnalyticalModel"
                                             (loadPreviewSender)="loadPreview($event)"></dataPreview>
                            </ng-container>
                        </ng-template>
                    </ngb-tab>
                </ngb-tabset>
            </div>
        </div>
    </div>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/pocdesigner/pocWizard.component.html